export const mutationTypes = {
	FILES_LOAD: 'FILES_LOAD',
	FILES_CREATE: 'FILES_CREATE',
	FILES_UPDATE: 'FILES_UPDATE',
	FILES_DESTROY: 'FILES_DESTROY'
};

export default {
	[mutationTypes.FILES_LOAD](state, data) {
		state.files = data
	},
	[mutationTypes.FILES_CREATE](state, data) {
		state.files.push(data)
	},
	[mutationTypes.FILES_UPDATE](state, data) {
		const i = state.files.findIndex(temp => temp.id == data.id)
        state.files[i] = data
        state.files = [...state.files]
	},
	[mutationTypes.FILES_DESTROY](state, data) {
		const i = state.files.findIndex(item => item.id == data.id)
		state.files.splice(i,1)
	}	
};
